import { useFeatureFlag } from '@moda/portal-stanchions';

export const useTwoFactorAuthenticationFeatureFlag = () => {
  const smsTwoFactorAuthEnabled = useFeatureFlag('two-factor-auth-sms', [
    { default: false },
    { if: true, then: true }
  ]);

  const appTwoFactorAuthEnabled = useFeatureFlag('two-factor-auth-app', [
    { default: false },
    { if: true, then: true }
  ]);

  return {
    enabled: appTwoFactorAuthEnabled || smsTwoFactorAuthEnabled,
    appTwoFactorAuthEnabled,
    smsTwoFactorAuthEnabled
  };
};
